export default "__VITE_ASSET__Bggp7fI5__"